import { render, staticRenderFns } from "./SingUpModal.vue?vue&type=template&id=60b8d5d4&scoped=true&"
import script from "./SingUpModal.vue?vue&type=script&lang=js&"
export * from "./SingUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SingUpModal.vue?vue&type=style&index=0&id=60b8d5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8d5d4",
  null
  
)

export default component.exports